import {Usuario} from '../interfaces/usuarios';
import Data from './datos_usuario';
import {Container, Row, Col, Image, Button} from 'react-bootstrap';
import logo from '../assets/logo_uct.png';
import '../App.css';
import {useNavigate} from 'react-router-dom';
import {FaArrowLeft} from 'react-icons/fa';
import {useState, useEffect} from 'react';

const Validar: React.FC<{userData: Usuario[]; registro: string}> = ({
	userData,
	registro,
}) => {
	const navigate = useNavigate();
	const [datosUsuario, setDatosUsuario] = useState<Usuario | null>(null);

	useEffect(() => {
		if (!userData || userData.length === 0 || !registro) {
			navigate('/home');
			return;
		}

		const foundUser = userData.find((user) => user.registro === registro);
		if (foundUser) {
			setDatosUsuario(foundUser);
		} else {
			navigate('/home');
		}
	}, [userData, registro, navigate]);

	if (!datosUsuario) {
		return null; // O un spinner de carga
	}
	return (
		<Container
			fluid
			className='d-flex flex-column'
			style={{minHeight: '100vh'}}>
			<Row>
				<Col className='d-flex justify-content-start ms-3'>
					<Button
						className='mt-4 ms-4 button'
						onClick={() => {
							navigate('/home');
						}}>
						<FaArrowLeft className='me-2' />
						Regresar
					</Button>
				</Col>
				<Col className='d-flex justify-content-start mt-3 me-5 pe-5'>
					<Image
						className='mt-2'
						src={logo}
						style={{width: 'auto', height: '60px'}}
					/>
				</Col>
			</Row>
			<Row className='ps-sm-5 ps-md-5'>
				<Col className='pt-5 order-md-2 order-sm-2'></Col>
				<Col className='pt-5 order-md-1 order-sm-1'>
					<span className='titulo-custom-validacion'>CREDENCIAL VIRTUAL</span>
				</Col>
			</Row>
			<Data usuario={datosUsuario} />
		</Container>
	);
};

export default Validar;
